import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IPrescriptionInfosResponse } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { PrescriptionService } from "src/app/providers/prescription.service";

export class PrescriptionsDataSource extends MatTableDataSourceBackendExtended<IPrescriptionInfosResponse> {
  public rawData$ = this.dataSubject.asObservable();

  constructor(private prescriptionService: PrescriptionService) {
    super();
  }

  public data(params: IDataSourceBackendParam): Observable<IPrescriptionInfosResponse[]> {
    return this.prescriptionService.getPendingPrescriptionInfos(params);
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
    Use this, the day we decide to make the page implements AbstractBackendTablePage
    return this.prescriptionService
      .getPrescriptionCount(param).pipe(map((response) => response.count));
    */
    return of(0);
  }
}
